import { BUSINESS_HOURS_TIME_CHANGE } from '../types'

export default function doBusinessHoursTimeChange(dayNumber, prop, value) {
  return {
    type: BUSINESS_HOURS_TIME_CHANGE,
    payload: {
      dayNumber,
      day: {
        [prop]: value,
      },
    },
  }
}
